/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S7_P1Inputs */

const en_guide_json_syntax_errors_s7_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When JSON refuses to parse, the cause is almost always mechanical rather than mysterious. Before you reach for a debugger, run through a short checklist. Are all keys and string values wrapped in double quotes rather than single ones? Is there a stray comma after the last item in an object or array? Does every opening brace and bracket have a matching close?`)
};

const ko_guide_json_syntax_errors_s7_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON이 파싱되지 않을 때 원인은 신비로운 것이 아니라 거의 늘 기계적인 실수입니다. 디버거를 켜기 전에 짧은 체크리스트를 훑어보세요. 모든 키와 문자열 값이 작은따옴표가 아닌 큰따옴표로 감싸여 있나요? 객체나 배열의 마지막 항목 뒤에 남은 쉼표는 없나요? 여는 중괄호와 대괄호마다 짝이 맞는 닫는 기호가 있나요?`)
};

const ja_guide_json_syntax_errors_s7_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON がパースできないとき、原因は不可解なものではなく、ほとんど常に機械的なミスです。デバッガーに手を伸ばす前に、短いチェックリストを確認しましょう。すべてのキーと文字列の値が、シングルではなくダブルクォートで囲まれていますか? オブジェクトや配列の最後の項目のあとに、余分なカンマが残っていませんか? 開き波括弧と角括弧のそれぞれに、対応する閉じがありますか?`)
};

/**
* | output |
* | --- |
* | "When JSON refuses to parse, the cause is almost always mechanical rather than mysterious. Before you reach for a debugger, run through a short checklist. Are..." |
*
* @param {Guide_Json_Syntax_Errors_S7_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s7_p1 = /** @type {((inputs?: Guide_Json_Syntax_Errors_S7_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S7_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s7_p1(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s7_p1(inputs)
	return ja_guide_json_syntax_errors_s7_p1(inputs)
});